import Datetime from 'helpers/Datetime';

const useFields = () => {
	const fields = {
		date: (value) => {
			return Datetime.displayDayWithHour(value);
		}
	}

	return {
		fields
	};
};

export default useFields;
